const func = $target => {
    console.log($target);

    var $el = $target.find('em'),
        delay = 2000,
        words = $target.data('words').split(','),
        loopNum = 0,
        txt = '',
        deleting = false;

    var tick = function() {
        var i = loopNum % words.length;
        var fullTxt = words[i];

        if (deleting) {
            txt = fullTxt.substring(0, txt.length - 1);
        } else {
            txt = fullTxt.substring(0, txt.length + 1);
        }

        $el.html(txt);
        $el.removeClass('end').removeClass('start');

        var delta = 200 - Math.random() * 100;

        if (deleting) {
            delta /= 2;
        }
        if (!deleting && txt === fullTxt) {
            delta = delay;
            deleting = true;
            $el.addClass('end');
        } else if (deleting && txt === '') {
            deleting = false;
            loopNum++;
            delta = 500;
            $el.addClass('start');
        }

        setTimeout(tick, delta);
    };

    tick();
};

export default func;